
<ng-container *ngIf="uuid; else elseTemplate">


  <ngx-extended-pdf-viewer 

  [src]="pdfSource" [showToolbar]="false" 
  [height]="dimensionW <= 420 ? '530vh':'450vh'"
  [showBorders]="false"
  [backgroundColor]="'#fff'"
    [zoom]="dimensionW < 600 ? '80%':'90%'" [useBrowserLocale]="true">
  </ngx-extended-pdf-viewer>


</ng-container>
<ng-template #elseTemplate>
  <div class="w-100" style="height: 500px;"></div>
</ng-template>
